var $1Kll1$reactjsxruntime = require("react/jsx-runtime");
var $1Kll1$react = require("react");
var $1Kll1$reactdom = require("react-dom");
var $1Kll1$lodash = require("lodash");
var $1Kll1$d3hierarchy = require("d3-hierarchy");
var $1Kll1$d3scale = require("d3-scale");
var $1Kll1$numeral = require("numeral");
var $1Kll1$platform = require("platform");
var $1Kll1$d3 = require("d3");
var $1Kll1$d3scalechromatic = require("d3-scale-chromatic");


      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $08ed429e2991b5a8$export$2e2bcd8739ae039);







const $856009e104b5527d$var$UNSIZED_LAYOUT = $1Kll1$d3hierarchy.cluster().separation(()=>1);
function $856009e104b5527d$export$2e2bcd8739ae039(width, height, taxonomy, currentDisplayInfo, rootNodeId, selectedTaxa) {
    const rootNode = taxonomy.indices.id[rootNodeId];
    return updateNodeCoordinates();
    // update x and y coordinates for currently visible nodes
    function updateNodeCoordinates() {
        // clear out any existing position information in readiness of calculating
        // it again.
        const incompleteNodeDisplayInfo = (0, ($parcel$interopDefault($1Kll1$lodash))).mapValues(currentDisplayInfo, (val)=>(0, ($parcel$interopDefault($1Kll1$lodash))).omit(val, [
                "x",
                "y",
                "offsetX",
                "offsetY",
                "lineThickness"
            ]));
        const layout = $856009e104b5527d$var$UNSIZED_LAYOUT.size([
            height,
            width
        ]);
        const myNodes = d3data(incompleteNodeDisplayInfo);
        const myRoot = $1Kll1$d3hierarchy.hierarchy(myNodes);
        const nodes = layout(myRoot).descendants();
        const strokeScale = getStrokeScale();
        for(let i = 0; i < nodes.length; i++){
            const node = nodes[i];
            const displayInfo = incompleteNodeDisplayInfo[node.data.id];
            displayInfo.x = node.x;
            displayInfo.y = node.y;
            displayInfo.lineThickness = strokeScale(node.data.proportion);
        }
        return updateRelativeNodeCoordinates(incompleteNodeDisplayInfo);
    }
    function getStrokeScale() {
        const maxScore = taxonomy.globalResultSetStats().maxProportion;
        const maxRange = maxScore >= 1 ? 2 : 5;
        return $1Kll1$d3scale.scaleLinear().domain([
            0,
            maxScore
        ]).range([
            .5,
            maxRange
        ]);
    }
    // get data structure of currently visible nodes
    function d3data(nodeDisplayInfo) {
        const isNodeExpanded = (node)=>(0, ($parcel$interopDefault($1Kll1$lodash))).get(nodeDisplayInfo[node.model.id], "expanded", false);
        const d3dataRecursive = (node)=>{
            const id = node.model.id;
            const proportion = node.model.results.proportion;
            const datum = {
                id: id,
                proportion: proportion
            };
            if (node.hasChildren()) datum.children = (0, ($parcel$interopDefault($1Kll1$lodash)))(node.children).filter(isNodeExpanded).map(d3dataRecursive).value();
            return datum;
        };
        return d3dataRecursive(rootNode);
    }
    function updateRelativeNodeCoordinates(incompleteNodeDisplayInfo) {
        const updateRecursive = (node, parentX = 0, parentY = 0, result = {}, depth = 0)=>{
            const nodeId = (0, ($parcel$interopDefault($1Kll1$lodash))).get(node, "model.id");
            if (!nodeId) throw new Error(`No nodeId for ${node}`);
            const displayInfo = result[nodeId] = (0, ($parcel$interopDefault($1Kll1$lodash))).cloneDeep(incompleteNodeDisplayInfo[nodeId]);
            if (!displayInfo) throw new Error(`No displayInfo for ${node.model.id}`);
            if (!(0, ($parcel$interopDefault($1Kll1$lodash))).isNumber(displayInfo.x)) ;
            else {
                displayInfo.offsetX = displayInfo.x - parentX;
                displayInfo.offsetY = displayInfo.y - parentY;
            }
            if (displayInfo.expanded && node.hasChildren()) node.children.map((child)=>updateRecursive(child, displayInfo.x, displayInfo.y, result, depth + 1));
            return result;
        };
        return (0, ($parcel$interopDefault($1Kll1$lodash))).assign(incompleteNodeDisplayInfo, updateRecursive(taxonomy));
    }
}


function $3ba3fb37090da528$export$f27c46a4165fa319(taxonomy, displayInfo) {
    return $3ba3fb37090da528$export$5d5aa51867371914(taxonomy, displayInfo).length;
}
function $3ba3fb37090da528$export$5d5aa51867371914(taxonomy, displayInfo) {
    if (displayInfo) return $3ba3fb37090da528$var$walkTreeForVisibleLeaves(taxonomy, displayInfo);
    else return taxonomy.leafNodes();
}
function $3ba3fb37090da528$var$walkTreeForVisibleLeaves(taxonomy, displayInfo) {
    const leaves = [];
    taxonomy.filterWalk((n)=>{
        const di = displayInfo[n.model.id];
        if (!di) throw new Error(`No display info for node ${n.model.id}`);
        if (di.expanded) {
            // if a node has no children, it's a leaf node (with a reference genome)
            if (!n.hasChildren()) {
                if (!n.model.genome) throw new Error(`Node ${_.get(n, "model.id")} has no genome`);
                leaves.push(n);
            }
            return true;
        }
    });
    return leaves;
}


const $124e2536d5ac167e$var$SMALL_SCREEN_WIDTH_PX = 480;
const $124e2536d5ac167e$var$TEXT_WIDTH_PX = 275;
const $124e2536d5ac167e$var$GENOME_PADDING_DEFAULT_PX = 2;
const $124e2536d5ac167e$var$GENOME_PADDING_SMALL_PX = 1.5;
const $124e2536d5ac167e$var$CIRCLE_RADIUS_DEFAULT_PX = 2.5;
const $124e2536d5ac167e$var$CIRCLE_RADIUS_SMALL_PX = 1.5;
const $124e2536d5ac167e$var$STROKE_WIDTH_DEFAULT_PX = 1; // px, defined in taxonomy.less;
const $124e2536d5ac167e$var$STROKE_WIDTH_SMALL_PX = $124e2536d5ac167e$var$STROKE_WIDTH_DEFAULT_PX;
const $124e2536d5ac167e$var$SPECIES_TREE_PROPORTION = 0.18;
const $124e2536d5ac167e$var$LEAF_NODE_HEIGHT_DEFAULT_PX = 12;
const $124e2536d5ac167e$var$LEAF_NODE_HEIGHT_SMALL_PX = 6.5;
const $124e2536d5ac167e$var$MARGIN_PX = 6;
function $124e2536d5ac167e$export$2e2bcd8739ae039(width) {
    const visWidth = width - $124e2536d5ac167e$var$MARGIN_PX;
    const showSpeciesNames = visWidth > $124e2536d5ac167e$var$SMALL_SCREEN_WIDTH_PX;
    let genomePadding;
    let leafNodeHeight;
    let circleRadius;
    let strokeWidth;
    let textWidth;
    if (showSpeciesNames) {
        genomePadding = $124e2536d5ac167e$var$GENOME_PADDING_DEFAULT_PX;
        leafNodeHeight = $124e2536d5ac167e$var$LEAF_NODE_HEIGHT_DEFAULT_PX;
        circleRadius = $124e2536d5ac167e$var$CIRCLE_RADIUS_DEFAULT_PX;
        strokeWidth = $124e2536d5ac167e$var$STROKE_WIDTH_DEFAULT_PX;
        textWidth = $124e2536d5ac167e$var$TEXT_WIDTH_PX + genomePadding;
    } else {
        genomePadding = $124e2536d5ac167e$var$GENOME_PADDING_SMALL_PX;
        leafNodeHeight = $124e2536d5ac167e$var$LEAF_NODE_HEIGHT_SMALL_PX;
        circleRadius = $124e2536d5ac167e$var$CIRCLE_RADIUS_SMALL_PX;
        strokeWidth = $124e2536d5ac167e$var$STROKE_WIDTH_SMALL_PX;
        textWidth = genomePadding;
    }
    const textProportion = textWidth / visWidth;
    const genomesProportion = 1 - $124e2536d5ac167e$var$SPECIES_TREE_PROPORTION - textProportion;
    const speciesTreeWidth = visWidth * $124e2536d5ac167e$var$SPECIES_TREE_PROPORTION;
    const genomesWidth = visWidth * genomesProportion;
    const genomesStart = visWidth - genomesWidth;
    return {
        layout: {
            genomesXStart: genomesStart,
            genomePadding: genomePadding,
            showSpeciesNames: showSpeciesNames,
            circleRadius: circleRadius,
            strokeWidth: strokeWidth,
            margin: $124e2536d5ac167e$var$MARGIN_PX
        },
        proportion: {
            text: textProportion,
            speciesTree: $124e2536d5ac167e$var$SPECIES_TREE_PROPORTION,
            genomes: genomesProportion
        },
        width: {
            vis: visWidth,
            genomes: genomesWidth,
            speciesTree: speciesTreeWidth,
            text: textWidth
        },
        height: {
            leafNode: leafNodeHeight
        }
    };
}









var $5e67d87d35f6489c$exports = {};

$5e67d87d35f6489c$exports = $1Kll1$platform.name === "IE" || $1Kll1$platform.name === "Microsoft Edge";


class $57385b6d93b04052$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($1Kll1$react))).Component {
    render() {
        return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsxs)("g", {
            className: this.className(),
            children: [
                /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("rect", {
                    x: "0",
                    y: "0",
                    width: "1",
                    height: "1",
                    ...this.rect1Props()
                }),
                /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("rect", {
                    x: "0",
                    y: "0",
                    width: "1",
                    height: "1",
                    ...this.rect2Props()
                })
            ]
        });
    }
    className() {
        let className = "edge";
        if (this.props.displayInfo.highlight) {
            console.log("HIGHLIGHT", this.props.node);
            className += " highlight";
        }
        return className;
    }
    rect1Props() {
        return this.rectProps((di, size, px)=>{
            const scaleX = -di.offsetY - size / 2;
            return `translate(0${px}, ${-size / 2}${px}) scale(${scaleX}, ${size})`;
        });
    }
    circleWidth() {
        return this.props.nodeRadius + this.props.strokeWidth / 2;
    }
    rect2Props() {
        const circleWidth = this.circleWidth();
        return this.rectProps((di, size, px)=>{
            // we need to take into account the size of the parent node.
            const scaleY = di.offsetX > 0 ? circleWidth - di.offsetX : -circleWidth - di.offsetX;
            return `translate(${-di.offsetY - size / 2}${px}, 0${px}) scale(${size}, ${scaleY})`;
        });
    }
    rectProps(getXform) {
        const di = this.props.displayInfo;
        const px = (0, (/*@__PURE__*/$parcel$interopDefault($5e67d87d35f6489c$exports))) ? "" : "px";
        const size = di.lineThickness;
        const transform = getXform(di, size, px);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5e67d87d35f6489c$exports))) ? {
            transform: transform
        } : {
            style: {
                transform: transform
            }
        };
    }
}




"use strict";
const $b28e2542aa883c86$var$Node = ({ node: node, displayInfo: displayInfo, onSelect: onSelect, radius: radius })=>/*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("g", {
        className: $b28e2542aa883c86$var$className(displayInfo),
        onClick: onSelect,
        children: /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("circle", {
            className: "circle",
            r: radius
        })
    });
function $b28e2542aa883c86$var$className(displayInfo) {
    let className = "node";
    if (displayInfo.highlight) className += " highlight";
    return className;
}
var $b28e2542aa883c86$export$2e2bcd8739ae039 = $b28e2542aa883c86$var$Node;



function $923e1d9e74d6570a$export$2e2bcd8739ae039(x, y) {
    const props = {};
    const isStyle = !(0, (/*@__PURE__*/$parcel$interopDefault($5e67d87d35f6489c$exports)));
    const px = isStyle ? "px" : "";
    if (0, (/*@__PURE__*/$parcel$interopDefault($5e67d87d35f6489c$exports))) props.transform = `translate(${x}${px}, ${y}${px})`;
    else props.style = {
        transform: `translate(${x}${px}, ${y}${px})`
    };
    return props;
}



class $412f91be2b3621a9$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($1Kll1$react))).Component {
    constructor(props){
        super(props);
        this.state = {
            className: "clade"
        };
    }
    addHighlightClass() {
        this.setClassNameState("clade highlight");
    }
    removeHighlightClass() {
        this.setClassNameState("clade");
    }
    notifyOfHover(e) {
        e.stopPropagation();
        this.props.onHighlight({
            name: `${this.props.node.model.name} has ${this.props.node.model.results.count} results`,
            taxon: this.props.node.model
        });
    }
    handleCladeSelection(e) {
        e.stopPropagation();
        this.props.onSelection({
            name: this.props.node.model.name,
            taxon: this.props.node.model
        });
    }
    setClassNameState(className) {
        if (this.state.className !== className) this.setState({
            className: className
        });
    }
    render() {
        return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsxs)("g", {
            className: this.state.className,
            ...this.gProps(),
            // use mouse enter/leave to set class for coloring path
            onMouseEnter: this.addHighlightClass.bind(this),
            onMouseLeave: this.removeHighlightClass.bind(this),
            // mouse over (with propagation stopped) for notifying others
            // of mouse over.
            onMouseOver: this.notifyOfHover.bind(this),
            onSelect: this.handleCladeSelection.bind(this),
            children: [
                this.renderEdge(),
                this.renderNode(),
                this.renderBackground(),
                this.renderText(),
                this.renderSubclades()
            ]
        });
    }
    renderEdge() {
        if (!this.props.isRoot) return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)((0, $57385b6d93b04052$export$2e2bcd8739ae039), {
            node: this.props.node,
            displayInfo: this.displayInfo(),
            nodeRadius: this.props.svgMetrics.layout.circleRadius,
            strokeWidth: this.props.svgMetrics.layout.strokeWidth
        });
    }
    renderNode() {
        return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)((0, $b28e2542aa883c86$export$2e2bcd8739ae039), {
            node: this.props.node,
            displayInfo: this.displayInfo(),
            radius: this.props.svgMetrics.layout.circleRadius
        });
    }
    renderText() {
        if (!this.props.node.hasChildren()) return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsxs)("g", {
            className: "node-label",
            children: [
                this.renderSpeciesName(),
                this.renderResultsCount()
            ]
        });
    }
    renderSpeciesName() {
        if (this.props.svgMetrics.layout.showSpeciesNames) return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("text", {
            x: "10",
            y: "4.75",
            className: "species-name",
            children: this.speciesName()
        });
    }
    renderBackground() {
        if (this.props.node.model.genome) {
            const { width: width, height: height } = this.props.svgMetrics;
            const y = 1 - height.leafNode / 2;
            return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("rect", {
                className: "species-background",
                x: "10",
                y: y,
                width: width.text + width.genomes,
                height: height.leafNode
            });
        }
    }
    renderResultsCount() {
        if (this.props.svgMetrics.layout.showSpeciesNames) {
            const x = this.props.svgMetrics.width.text - 2 * this.props.svgMetrics.layout.genomePadding;
            return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("text", {
                x: x,
                y: "4.75",
                className: "results-count",
                textAnchor: "end",
                children: (0, ($parcel$interopDefault($1Kll1$numeral)))(this.props.node.model.results.count).format("0,0")
            });
        }
    }
    speciesName() {
        const fullName = this.props.node.model.name;
        const removedExtraineousWords = fullName.replace(/( Group$| subsp\.| ssp\.| var\.| strain)/, "");
        let finalVersion;
        if (removedExtraineousWords.length > 20) {
            let words = removedExtraineousWords.split(" ");
            if (words.length === 2) // abrreviate first word.
            finalVersion = removedExtraineousWords.replace(/^([A-Z])[a-z]+/, "$1.");
            if (words.length > 2) finalVersion = removedExtraineousWords.replace(/^([A-Z])[a-z]+\s([a-z])[a-z]+/, "$1$2.");
        } else finalVersion = removedExtraineousWords;
        return finalVersion;
    }
    renderSubclades() {
        // if (this.showChildren()) {
        const propsPassthrough = (0, ($parcel$interopDefault($1Kll1$lodash))).pick(this.props, [
            "nodeDisplayInfo",
            "svgMetrics",
            "highlight",
            "selection",
            "inProgressSelection",
            "onSelection",
            "onSelectionStart",
            "onHighlight"
        ]);
        const nodeDisplayInfo = this.props.nodeDisplayInfo;
        return (0, ($parcel$interopDefault($1Kll1$lodash)))(this.props.node.children).filter((child)=>{
            const childInfo = nodeDisplayInfo[child.model.id];
            return (0, ($parcel$interopDefault($1Kll1$lodash))).get(childInfo, "expanded", false);
        }).map((child)=>{
            const key = (0, ($parcel$interopDefault($1Kll1$lodash))).get(child, "model.id");
            if (!(0, ($parcel$interopDefault($1Kll1$lodash))).isNumber(key)) throw new Error("No node id for child!");
            return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)($412f91be2b3621a9$export$2e2bcd8739ae039, {
                node: child,
                ...propsPassthrough
            }, key);
        }).value();
    // }
    }
    gProps() {
        return (0, $923e1d9e74d6570a$export$2e2bcd8739ae039)(this.displayInfo().offsetY, this.displayInfo().offsetX);
    }
    componentWillMount() {
        const node = this.props.node;
        this.nodeId = (0, ($parcel$interopDefault($1Kll1$lodash))).get(node, "model.id");
        if (!(0, ($parcel$interopDefault($1Kll1$lodash))).isNumber(this.nodeId)) throw new Error(`No node id found!`);
    }
    displayInfo() {
        return this.props.nodeDisplayInfo[this.nodeId];
    }
}






const $c4cd86894eca6282$var$regionColors = $1Kll1$d3scalechromatic.schemeCategory10;
const $c4cd86894eca6282$var$unanchoredColor = "#d3d3d3";
const $c4cd86894eca6282$var$baseColors = $1Kll1$d3scalechromatic.schemeCategory10;
// const baseColors = d3.scaleOrdinal(d3.schemeCategory10);
// const baseColors = ['#547b74', '#9abe6c'];
const $c4cd86894eca6282$var$regionColorScales = $c4cd86894eca6282$var$baseColors.map((color)=>$1Kll1$d3.scaleLinear().domain([
        0,
        1
    ]).range([
        "#FFFFFF",
        color
    ]));
const $c4cd86894eca6282$var$binColorScales = $c4cd86894eca6282$var$regionColorScales.map((scale, idx)=>$1Kll1$d3.scalePow().exponent(0.4).domain([
        0,
        1
    ]).range([
        scale(0.15),
        $c4cd86894eca6282$var$baseColors[idx]
    ]));
function $c4cd86894eca6282$export$ecd521500f0c73a1(regionIdx, isUnanchored) {
    if (isUnanchored) return $c4cd86894eca6282$var$unanchoredColor;
    const idx = regionIdx % $c4cd86894eca6282$var$regionColors.length;
    return $c4cd86894eca6282$var$regionColors[idx];
}
function $c4cd86894eca6282$export$188f209dcef43618(regionIdx, binScore, isUnanchored) {
    if (isUnanchored) return $c4cd86894eca6282$var$unanchoredColor;
    const idx = regionIdx % $c4cd86894eca6282$var$regionColors.length;
    return $c4cd86894eca6282$var$binColorScales[idx](binScore);
}



function $181c61c8a6bd5396$export$42ffd38884aecdac(ctx) {
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
}


function $29fa6aea70318279$export$3380fc6bdc12eb9(highlight) {
    if (!highlight.genome) return "nothing here";
    let name = highlight.genome.system_name;
    if (!highlight.region) return name;
    name += ` ${highlight.region.name}`;
    if (!highlight.bins) return name;
    const startBase = (0, ($parcel$interopDefault($1Kll1$lodash))).head(highlight.bins).start;
    const endBase = (0, ($parcel$interopDefault($1Kll1$lodash))).last(highlight.bins).end;
    name += `:${startBase}-${endBase}`;
    return name;
}
function $29fa6aea70318279$export$e42238dd896ae5a8(ctx, genomes, metrics, globalStats) {
    (0, $181c61c8a6bd5396$export$42ffd38884aecdac)(ctx);
    return (0, ($parcel$interopDefault($1Kll1$lodash)))(genomes).map((genome, idx)=>{
        const x = metrics.padding;
        const y = idx * metrics.height + metrics.margin;
        const xPixels = $29fa6aea70318279$var$drawGenome({
            genome: genome,
            genomeCtx: ctx,
            x: x,
            y: y,
            globalStats: globalStats,
            width: metrics.width,
            height: metrics.unpaddedHeight
        });
        return {
            genome: genome,
            xPixels: xPixels,
            y: y,
            height: metrics.height
        };
    }).keyBy("y").value();
}
function $29fa6aea70318279$var$drawGenome({ genome: genome, genomeCtx: genomeCtx, x: x, y: y, width: width, height: height, globalStats: globalStats }) {
    const basesPerPx = genome.fullGenomeSize / width;
    const regions = genome._regionsArray;
    const maxScore = globalStats.bins.max;
    const pixelInfo = {};
    let binIdx = 0;
    let binFirstPx = x;
    let basesInBinUsedAlready = 0;
    let basesNeededByThisPixel;
    let bin;
    let binSize;
    let binScore;
    let basesAvailableInBin;
    let regionIdx = 0;
    let region = regions[regionIdx];
    let regionDims = {
        x: x,
        width: Math.floor(region.size / basesPerPx)
    };
    let regionUnanchored = region.name === "UNANCHORED";
    for(let px = x; px < width + x; px++){
        const pxInfo = {
            bins: [],
            x: binFirstPx,
            region: region,
            regionDims: regionDims,
            genome: genome,
            score: undefined,
            baseCount: 0
        };
        while(pxInfo.baseCount < basesPerPx){
            basesNeededByThisPixel = basesPerPx - pxInfo.baseCount;
            bin = region.bin(binIdx);
            binSize = bin.end - bin.start + 1;
            binScore = maxScore ? bin.results.count / maxScore : 0;
            basesAvailableInBin = binSize - basesInBinUsedAlready;
            pxInfo.bins.push(bin);
            // did we use all the bases in the bin?
            let binBasesUsed;
            if (basesAvailableInBin <= basesNeededByThisPixel) {
                // if yes, we'll move on to the next one.
                binIdx++;
                binFirstPx = px;
                basesInBinUsedAlready = 0;
                binBasesUsed = basesAvailableInBin;
            } else {
                // otherwise, track how many bases we have used.
                basesInBinUsedAlready += basesNeededByThisPixel;
                binBasesUsed = basesNeededByThisPixel;
            }
            pxInfo.score = $29fa6aea70318279$var$updateScore(pxInfo.score, pxInfo.baseCount, binScore, binBasesUsed);
            pxInfo.baseCount += binBasesUsed;
            // if the new bin index is too big for the region,
            // go to the next region and set bin index to 0
            if (binIdx === region.binCount()) {
                binIdx = 0;
                ++regionIdx;
                if (regionIdx === regions.length) break;
                region = pxInfo.region = regions[regionIdx];
                regionDims = pxInfo.regionDims = {
                    x: px,
                    width: Math.ceil(region.size / basesPerPx)
                };
                regionUnanchored = region.name === "UNANCHORED";
            }
        }
        genomeCtx.fillStyle = (0, $c4cd86894eca6282$export$188f209dcef43618)(regionIdx, pxInfo.score, regionUnanchored);
        genomeCtx.fillRect(px, y, 1, height);
        pxInfo.width = px - pxInfo.x + Math.floor(basesAvailableInBin / basesPerPx);
        pixelInfo[px] = pxInfo;
    }
    return pixelInfo;
}
function $29fa6aea70318279$var$updateScore(currentScore, baseCount, binScore, binBasesUsed) {
    let newScore;
    if ((0, ($parcel$interopDefault($1Kll1$lodash))).isNumber(currentScore)) {
        if (baseCount === 0) throw new Error("There should already be bases accounted for in this pixel");
        // weight scores.
        newScore = (currentScore * baseCount + binScore * binBasesUsed) / (binBasesUsed + baseCount);
    } else {
        if (baseCount !== 0) throw new Error("There should already be a color");
        newScore = binScore;
    }
    return newScore;
}




function $e0b1c9ed93c3930a$export$88d60b1cf1c6237e(highlight, selection, inProgressSelection, ctx) {
    (0, $181c61c8a6bd5396$export$42ffd38884aecdac)(ctx);
    if (!(0, ($parcel$interopDefault($1Kll1$lodash))).isEmpty(selection)) $e0b1c9ed93c3930a$var$drawSelections(selection, ctx);
    if (!(0, ($parcel$interopDefault($1Kll1$lodash))).isEmpty(inProgressSelection)) $e0b1c9ed93c3930a$var$drawInProgressSelection(highlight, inProgressSelection, ctx);
    else $e0b1c9ed93c3930a$var$drawHighlight(highlight, ctx);
}
function $e0b1c9ed93c3930a$var$drawSelections(selections, ctx) {
    (0, ($parcel$interopDefault($1Kll1$lodash)))(selections).filter((selection)=>selection.select).forEach((selection)=>{
        if ($e0b1c9ed93c3930a$var$isSelectionBad(selection)) return;
        const { x: x, width: width, y: y, height: height } = selection;
        ctx.strokeStyle = "red";
        ctx.strokeRect(x - 1, y - 1, width + 1, height);
    });
}
function $e0b1c9ed93c3930a$var$drawHighlight(highlight, ctx) {
    if ($e0b1c9ed93c3930a$var$isHighlightBad(highlight)) return;
    const { x: x, width: width, y: y, height: height } = highlight;
    ctx.strokeStyle = "green";
    ctx.strokeRect(x - 1, y - 1, width + 1, height);
}
function $e0b1c9ed93c3930a$var$drawInProgressSelection(highlight, inProgressSelection, ctx) {
    if ($e0b1c9ed93c3930a$var$isHighlightBad(highlight)) return;
    if ($e0b1c9ed93c3930a$var$isSelectionBad(inProgressSelection)) return;
    let start, end;
    if ((0, ($parcel$interopDefault($1Kll1$lodash))).head(highlight.bins).idx > inProgressSelection.binFrom.idx) {
        start = inProgressSelection;
        end = highlight;
    } else {
        start = highlight;
        end = inProgressSelection;
    }
    const { y: y, height: height } = highlight;
    const xRange = {
        x: Math.min(start.x, end.x),
        width: end.x - start.x + end.width
    };
    ctx.strokeStyle = "green";
    ctx.strokeRect(xRange.x - 1, y - 1, xRange.width + 1, height);
}
function $e0b1c9ed93c3930a$var$isHighlightBad(highlight) {
    return !highlight || !highlight.genome || !highlight.bins || !highlight.bins.length;
}
function $e0b1c9ed93c3930a$var$isSelectionBad(sel) {
    return !sel || !sel.genome || !sel.binTo || !sel.binFrom;
}



class $530496d5ae59225d$export$2e2bcd8739ae039 {
    constructor(...listOfPaths){
        const badPaths = (0, ($parcel$interopDefault($1Kll1$lodash))).filter(listOfPaths, (path)=>!((0, ($parcel$interopDefault($1Kll1$lodash))).isString(path) || $530496d5ae59225d$export$2e2bcd8739ae039.isPathObject(path)));
        if (badPaths.length) {
            console.log("badpaths", badPaths);
            throw new Error(`${badPaths.length} paths that can't be used`);
        }
        this.listOfPaths = listOfPaths;
    }
    differ(stateA, stateB) {
        return !!(0, ($parcel$interopDefault($1Kll1$lodash))).find(this.listOfPaths, (thePath)=>{
            if ((0, ($parcel$interopDefault($1Kll1$lodash))).isString(thePath)) return $530496d5ae59225d$export$2e2bcd8739ae039.stringDiffer(stateA, stateB, thePath);
            else if ($530496d5ae59225d$export$2e2bcd8739ae039.isPathObject(thePath)) return $530496d5ae59225d$export$2e2bcd8739ae039.objectDiffer(stateA, stateB, thePath);
        });
    }
    static isPathObject(path) {
        return (0, ($parcel$interopDefault($1Kll1$lodash))).isObject(path) && !((0, ($parcel$interopDefault($1Kll1$lodash))).isUndefined(path.path) || (0, ($parcel$interopDefault($1Kll1$lodash))).isUndefined(path.referenceValue));
    }
    static stringDiffer(stateA, stateB, thePath) {
        const a = (0, ($parcel$interopDefault($1Kll1$lodash))).get(stateA, thePath);
        const b = (0, ($parcel$interopDefault($1Kll1$lodash))).get(stateB, thePath);
        return !(0, ($parcel$interopDefault($1Kll1$lodash))).isEqual(a, b);
    }
    static objectDiffer(stateA, stateB, thePath) {
        const { referenceValue: referenceValue, path: path } = thePath;
        const a = $530496d5ae59225d$export$2e2bcd8739ae039.matchesReferenceValue(stateA, path, referenceValue);
        const b = $530496d5ae59225d$export$2e2bcd8739ae039.matchesReferenceValue(stateB, path, referenceValue);
        return a || b;
    }
    static matchesReferenceValue(state, path, referenceValue) {
        return !(0, ($parcel$interopDefault($1Kll1$lodash))).isEqual((0, ($parcel$interopDefault($1Kll1$lodash))).get(state, path), referenceValue);
    }
}



function $ca3c19a284cf9b05$export$2e2bcd8739ae039(start, end) {
    $ca3c19a284cf9b05$var$checkSelection(start);
    $ca3c19a284cf9b05$var$checkSelection(end);
    $ca3c19a284cf9b05$var$checkSelectionsOnSameGenome(start, end);
    if (start === end) return start;
    let first, last;
    if (start.binFrom.idx < end.binFrom.idx) {
        first = start;
        last = end;
    } else {
        first = end;
        last = start;
    }
    const selection = (0, ($parcel$interopDefault($1Kll1$lodash))).omit(first, [
        "binFrom",
        "binTo",
        "x"
    ]);
    selection.binFrom = first.binFrom;
    selection.binTo = last.binTo;
    selection.x = first.x;
    selection.width = last.x - first.x + last.width;
    return selection;
}
function $ca3c19a284cf9b05$var$checkSelection(s) {
    if (!s || !(0, ($parcel$interopDefault($1Kll1$lodash))).isObject(s) || !s.genome || !s.region || !s.binFrom || !s.binTo) throw Error("Selection object invalid", s);
}
function $ca3c19a284cf9b05$var$checkSelectionsOnSameGenome(start, end) {
    if (!(0, ($parcel$interopDefault($1Kll1$lodash))).isNumber(start.genome.taxon_id) || !(0, ($parcel$interopDefault($1Kll1$lodash))).isEqual(start.genome.taxon_id, end.genome.taxon_id)) throw new Error("Selection start and end are on different genomes");
}



class $26ed8e186f907c39$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($1Kll1$react))).Component {
    constructor(props){
        super(props);
        this.genomesCanvasRef = /*#__PURE__*/ (0, ($parcel$interopDefault($1Kll1$react))).createRef();
        this.highlightCanvasRef = /*#__PURE__*/ (0, ($parcel$interopDefault($1Kll1$react))).createRef();
        this.state = {
            events: []
        };
        this.doGenomeRedrawProps = new (0, $530496d5ae59225d$export$2e2bcd8739ae039)("globalStats.timesSetResultsHasBeenCalled", "svgMetrics", "nodeDisplayInfo");
        this.doHighlightRedrawProps = new (0, $530496d5ae59225d$export$2e2bcd8739ae039)("highlight", "selection", "inProgressSelection");
    }
    componentWillReceiveProps(props) {
        this.genomeCanvasDirty = this.doGenomeRedrawProps.differ(props, this.props);
        this.highlightCanvasDirty = this.doHighlightRedrawProps.differ(props, this.props);
    }
    componentDidMount() {
        this.drawImage();
        this.drawHighlightsAndSelections();
    }
    componentDidUpdate() {
        if (this.genomeCanvasDirty) {
            this.drawImage();
            this.genomeCanvasDirty = false;
        }
        if (this.highlightCanvasDirty) {
            this.drawHighlightsAndSelections();
            this.highlightCanvasDirty = false;
        }
    }
    metrics(props = this.props) {
        const padding = props.svgMetrics.layout.genomePadding;
        const margin = props.svgMetrics.layout.margin;
        const width = props.svgMetrics.width.genomes;
        const height = props.svgMetrics.height.leafNode;
        const unpaddedHeight = height - padding;
        return {
            padding: padding,
            margin: margin,
            width: width,
            height: height,
            unpaddedHeight: unpaddedHeight
        };
    }
    drawImage(props = this.props) {
        const metrics = this.metrics(props);
        const globalStats = props.globalStats;
        const ctx = this.genomesCanvasRef.current.getContext("2d");
        const objectLocations = (0, $29fa6aea70318279$export$e42238dd896ae5a8)(ctx, props.genomes, metrics, globalStats);
        this.setState({
            objectLocations: objectLocations
        });
    }
    drawHighlightsAndSelections(props = this.props) {
        const ctx = this.highlightCanvasRef.current.getContext("2d");
        (0, $e0b1c9ed93c3930a$export$88d60b1cf1c6237e)(props.highlight, props.selections, props.inProgressSelection, ctx);
    }
    getHighlightFromEventCoordinates(coords) {
        let highlight = this.getHighlightCoords(coords);
        if (this.state.objectLocations) {
            const objectLocations = this.state.objectLocations[highlight.y];
            if (objectLocations && objectLocations.xPixels) (0, ($parcel$interopDefault($1Kll1$lodash))).assign(highlight, objectLocations.xPixels[highlight.x]);
        }
        highlight.name = (0, $29fa6aea70318279$export$3380fc6bdc12eb9)(highlight);
        return highlight;
    }
    getHighlightCoords(coords) {
        const { offsetX: offsetX, offsetY: offsetY } = coords;
        const { margin: margin, height: height } = this.metrics();
        // if we have an in-progress selection, then take Y coord from that
        // in order to maintain selection in same genome.
        const y = (0, ($parcel$interopDefault($1Kll1$lodash))).get(this.props.inProgressSelection, "y", offsetY);
        return {
            x: offsetX,
            y: y - (y - margin) % height,
            height: height
        };
    }
    getSelectionFromEventCoordinates(coords) {
        const highlight = this.getHighlightFromEventCoordinates(coords);
        const selection = (0, ($parcel$interopDefault($1Kll1$lodash))).omit(highlight, "bins");
        selection.binFrom = (0, ($parcel$interopDefault($1Kll1$lodash))).head(highlight.bins);
        selection.binTo = (0, ($parcel$interopDefault($1Kll1$lodash))).last(highlight.bins);
        // if the first bin is already selected, we will be deselecting.
        selection.select = !this.isBinAlreadySelected(selection.binFrom);
        return selection;
    }
    isBinAlreadySelected(bin) {
        return !!(0, ($parcel$interopDefault($1Kll1$lodash))).find(this.props.selections, (selection)=>selection.binFrom && selection.binFrom.idx <= bin.idx && selection.binTo.idx >= bin.idx);
    }
    getOffsetCoordsForTouchEvent(e) {
        const firstTouch = (0, ($parcel$interopDefault($1Kll1$lodash))).get(e.nativeEvent, "touches[0]");
        if (!firstTouch) throw new Error("No touch information in event", e);
        const offsetX = firstTouch.pageX - firstTouch.target.offsetLeft;
        const offsetY = firstTouch.pageY - firstTouch.target.offsetTop;
        return {
            offsetX: offsetX,
            offsetY: offsetY
        };
    }
    onMouseMove(e) {
        this.logEvent(e);
        e.preventDefault();
        this.handleMove(e.nativeEvent);
    }
    onTouchMove(e) {
        this.logEvent(e);
        e.preventDefault();
        e.stopPropagation();
        this.handleMove(this.getOffsetCoordsForTouchEvent(e));
    }
    handleMove(coords) {
        this.props.onHighlight(this.getHighlightFromEventCoordinates(coords));
    }
    onMouseDown(e) {
        this.logEvent(e);
        this.handleSelectionStart(e.nativeEvent);
    }
    onTouchStart(e) {
        e.preventDefault();
        e.stopPropagation();
        this.logEvent(e);
        this.handleSelectionStart(this.getOffsetCoordsForTouchEvent(e));
    }
    handleSelectionStart(coords) {
        this.props.onSelectionStart(this.getSelectionFromEventCoordinates(coords));
    }
    onTouchEnd(e) {
        e.preventDefault();
        e.stopPropagation();
        this.logEvent(e);
        this.handleSelection(this.getOffsetCoordsForTouchEvent(e));
    }
    handleSelection(coords) {
        const selectionStart = this.props.inProgressSelection;
        if (selectionStart) {
            // Lock Y coordinate like this in order to allow contiguous selection
            // *within a genome*
            const fakeCoords = {
                offsetX: coords.offsetX,
                offsetY: selectionStart.y
            };
            const selectionEnd = this.getSelectionFromEventCoordinates(fakeCoords);
            this.props.onSelection((0, $ca3c19a284cf9b05$export$2e2bcd8739ae039)(selectionStart, selectionEnd));
        }
    }
    onClick(e) {
        this.logEvent(e);
        e.preventDefault();
        e.stopPropagation();
        const numberOfClicks = e.nativeEvent.detail;
        const ne = e.nativeEvent;
        if (numberOfClicks === 1) {
            this.handleSelection(ne);
            return;
        }
        const selection = this.getSelectionFromEventCoordinates(ne);
        switch(numberOfClicks){
            case 2:
                this.selectRegion(selection);
                break;
            case 3:
                this.selectGenome(selection);
                break;
        }
    }
    selectRegion(selection) {
        const { region: region, regionDims: regionDims } = selection;
        selection.binFrom = region.firstBin();
        selection.binTo = region.bin(region.binCount() - 1);
        selection.x = regionDims.x;
        selection.width = regionDims.width;
        selection.select = !selection.select; // it's state was changed on the first click.
        this.props.onSelection(selection);
    }
    selectGenome(selection) {
        const rootNode = this.props.rootNode;
        const genome = selection.genome;
        const metrics = this.metrics();
        selection.binFrom = rootNode.getBin(genome.startBin);
        selection.binTo = rootNode.getBin(genome.startBin + genome.nbins - 1);
        selection.x = metrics.padding;
        selection.width = metrics.width;
        selection.select = !selection.select; // it's state was changed on the previous two clicks
        this.props.onSelection(selection);
    }
    cancelSelection(e) {
        this.logEvent(e);
        this.props.onSelectionStart();
    }
    logEvent(e) {
        const { type: type, nativeEvent: { offsetX: offsetX, offsetY: offsetY, detail: detail, touches: touches } } = e;
        const info = detail || touches && touches.length;
        const time = new Date();
        this.setState({
            events: (0, ($parcel$interopDefault($1Kll1$lodash))).concat([], {
                type: type,
                offsetX: offsetX,
                offsetY: offsetY,
                info: info,
                time: time
            }, this.state.events)
        });
    }
    eventLog() {
        return this.state.events.map((e)=>/*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsxs)("li", {
                children: [
                    String(e.time.getTime()).substr(8),
                    " ",
                    e.type,
                    ": (",
                    e.offsetX,
                    ", ",
                    e.offsetY,
                    ") detail: ",
                    e.detail
                ]
            }, e.time.getTime()));
    }
    render() {
        const metrics = this.props.svgMetrics;
        const dimensions = {
            height: this.props.genomes.length * metrics.height.leafNode + metrics.layout.margin,
            width: metrics.width.genomes + metrics.layout.genomePadding * 2
        };
        return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsxs)("div", {
            className: "genomes",
            children: [
                /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("canvas", {
                    ref: this.genomesCanvasRef,
                    ...dimensions
                }),
                /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("canvas", {
                    ref: this.highlightCanvasRef,
                    ...dimensions,
                    onClick: this.onClick.bind(this),
                    onMouseDown: this.onMouseDown.bind(this),
                    onMouseMove: this.onMouseMove.bind(this),
                    onMouseOut: this.cancelSelection.bind(this),
                    onTouchStart: this.onTouchStart.bind(this),
                    onTouchMove: this.onTouchMove.bind(this),
                    onTouchEnd: this.onTouchEnd.bind(this),
                    onTouchCancel: this.cancelSelection.bind(this)
                })
            ]
        });
    }
}





function $565d4ca0b99315ee$export$2e2bcd8739ae039(selections, newSelection) {
    // add or subtract one because we may need to modify selections immediately adjacent.
    const start = newSelection.binFrom.idx - 1;
    const end = newSelection.binTo.idx + 1;
    const taxonId = newSelection.genome.taxon_id;
    const partitioned = (0, ($parcel$interopDefault($1Kll1$lodash))).partition(selections, (selection)=>{
        const from = (0, ($parcel$interopDefault($1Kll1$lodash))).get(selection.binFrom, "idx");
        const to = (0, ($parcel$interopDefault($1Kll1$lodash))).get(selection.binTo, "idx");
        return taxonId === (0, ($parcel$interopDefault($1Kll1$lodash))).get(selection.genome, "taxon_id") && !(from > end || to < start);
    });
    return {
        toUpdate: partitioned[0],
        toLeave: partitioned[1]
    };
}



function $f544a09c7aaad705$export$2e2bcd8739ae039(newSelection, oldSelection) {
    if (oldSelection.select !== newSelection.select) throw new Error("Can only merge selections if they are both the same type");
    const { genome: { taxon_id: oldTaxonId }, binFrom: { idx: oldStartIdx }, binTo: { idx: oldEndIdx } } = oldSelection;
    const { genome: { taxon_id: newTaxonId }, binFrom: { idx: newStartIdx }, binTo: { idx: newEndIdx } } = newSelection;
    if (oldTaxonId !== newTaxonId) throw new Error("Adjacent bins on different genomes. Will not merge.");
    const updatedNewSelection = (0, ($parcel$interopDefault($1Kll1$lodash))).clone(newSelection);
    if (oldStartIdx < newStartIdx) {
        if (oldEndIdx + 1 < newStartIdx) throw new Error("Selections don't overlap/are not adjacent");
        updatedNewSelection.binFrom = oldSelection.binFrom;
        updatedNewSelection.x = oldSelection.x;
        updatedNewSelection.width = updatedNewSelection.width + newSelection.x - oldSelection.x;
    }
    if (oldEndIdx > newEndIdx) {
        if (oldStartIdx - 1 > newEndIdx) throw new Error("Selections don't overlap/are not adjacent");
        updatedNewSelection.binTo = oldSelection.binTo;
        updatedNewSelection.width = oldSelection.width + oldSelection.x - updatedNewSelection.x;
    }
    return updatedNewSelection;
}



function $3adf4dbbc1fb6445$export$4df50c43964c29ef(newSelection, oldSelection, rootNode) {
    $3adf4dbbc1fb6445$var$commonChecks(oldSelection, newSelection);
    const updatedEndIdx = newSelection.binFrom.idx - 1;
    if (updatedEndIdx < oldSelection.binFrom.idx) throw new Error("Cannot end selection before it starts");
    const updatedEnd = rootNode.getBin(updatedEndIdx);
    const updatedSelectionBefore = (0, ($parcel$interopDefault($1Kll1$lodash))).clone(oldSelection);
    updatedSelectionBefore.binTo = updatedEnd;
    updatedSelectionBefore.width = newSelection.x - oldSelection.x;
    return updatedSelectionBefore;
}
function $3adf4dbbc1fb6445$export$d9ca64303a4c5d71(newSelection, oldSelection, rootNode) {
    $3adf4dbbc1fb6445$var$commonChecks(oldSelection, newSelection);
    const updatedStartIdx = newSelection.binTo.idx + 1;
    if (updatedStartIdx > oldSelection.binTo.idx) throw new Error("Cannot start selection after it ends");
    const updatedStart = rootNode.getBin(updatedStartIdx);
    const updatedSelectionAfter = (0, ($parcel$interopDefault($1Kll1$lodash))).clone(oldSelection);
    updatedSelectionAfter.binFrom = updatedStart;
    updatedSelectionAfter.x = newSelection.x + newSelection.width;
    updatedSelectionAfter.width = oldSelection.x + oldSelection.width - updatedSelectionAfter.x;
    return updatedSelectionAfter;
}
function $3adf4dbbc1fb6445$var$commonChecks(oldS, newS) {
    if (oldS.select === newS.select) throw new Error("These selections should be merged!");
    if (newS.binFrom.idx < oldS.binFrom.idx && newS.binTo.idx > oldS.binTo.idx) throw new Error("Old bin should be removed, not trimmed");
    if (newS.binFrom.idx > oldS.binTo.idx || newS.binTo.idx < oldS.binFrom.idx) throw new Error("No appropriate overlap for trim");
}


function $eb703776a00ee55e$export$2e2bcd8739ae039(acc, oldSelection, rootNode) {
    const newSelection = acc.modifiedNewSelection;
    const { genome: { taxon_id: oldTaxonId }, binFrom: { idx: oldStartIdx }, binTo: { idx: oldEndIdx } } = oldSelection;
    const { genome: { taxon_id: newTaxonId }, binFrom: { idx: newStartIdx }, binTo: { idx: newEndIdx } } = newSelection;
    if (oldTaxonId !== newTaxonId || oldEndIdx + 1 < newStartIdx && oldStartIdx < newStartIdx || oldStartIdx - 1 > newEndIdx && oldEndIdx > newEndIdx) throw new Error("Selections don't overlap/are not adjacent");
    /*
   If overlapping or adjacent selections are the same
   type (e.g. both have "select" === true) and are on
   the same genome, then we should merge them into the
   new selection.
   */ if (oldSelection.select === newSelection.select) acc.modifiedNewSelection = (0, $f544a09c7aaad705$export$2e2bcd8739ae039)(newSelection, oldSelection);
    else if (oldStartIdx >= newStartIdx && oldEndIdx <= newEndIdx) ;
    else {
        /* NB it's possible for both of the following conditions to be true */ /* case 2: newSelection overwrites end of old selection
     oldSelection:       |-------------|
     newSelection:               |---------...
     updatedSelections:  |------|
     */ if (oldStartIdx < newStartIdx && oldEndIdx >= newStartIdx) acc.updated.push((0, $3adf4dbbc1fb6445$export$4df50c43964c29ef)(newSelection, oldSelection, rootNode));
        /* case 3: newSelection overwrites start of oldSelection
     oldSelection:               |------------|
     newSelection:       ...-----------|
     updatedSelections:                 |-----|
     */ if (oldStartIdx <= newEndIdx && oldEndIdx > newEndIdx) acc.updated.push((0, $3adf4dbbc1fb6445$export$d9ca64303a4c5d71)(newSelection, oldSelection, rootNode));
    }
    return acc;
}


function $62cb6e6f9f8e464a$export$2e2bcd8739ae039(existingSelectionsToUpdate, rootNode, newSelection) {
    return existingSelectionsToUpdate.reduce((acc, oldSelection)=>(0, $eb703776a00ee55e$export$2e2bcd8739ae039)(acc, oldSelection, rootNode), {
        modifiedNewSelection: newSelection,
        updated: []
    });
}


function $eeb63405e607c2a2$export$6c7848d79ea81085(newSelection, currentSelectionState, rootNode) {
    // find any existing selections that will be affected by the new one.
    const { toUpdate: toUpdate, toLeave: toLeave } = (0, $565d4ca0b99315ee$export$2e2bcd8739ae039)(currentSelectionState, newSelection);
    // modify the new selection and any existing ones that overlap
    // in order to remove overlaps
    const { modifiedNewSelection: modifiedNewSelection, updated: updated } = (0, $62cb6e6f9f8e464a$export$2e2bcd8739ae039)(toUpdate, rootNode, newSelection);
    const newSelections = [
        ...toLeave,
        ...updated
    ];
    // add the new selection if it is a selection (i.e. not a deselection).
    if (modifiedNewSelection.select) newSelections.push(modifiedNewSelection);
    return newSelections;
}



class $51d08e07ac9e9607$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($1Kll1$react))).Component {
    constructor(props){
        super(props);
        this.state = {
            inProgressSelection: {},
            selections: [],
            highlight: {}
        };
    }
    expandedNodesWillChange(newNodeDisplayInfo) {
        return !(0, ($parcel$interopDefault($1Kll1$lodash))).isEqualWith(newNodeDisplayInfo, this.props.nodeDisplayInfo, (a, b)=>a.expanded == b.expanded);
    }
    componentWillReceiveProps(newProps) {
        if (this.expandedNodesWillChange(newProps.nodeDisplayInfo)) {
            console.log("Clearing selection state because expanded nodes will change");
            this.setState({
                selections: []
            });
        }
    }
    handleSelectionStart(selection) {
        this.setState({
            inProgressSelection: selection
        });
    }
    handleSelection(selection) {
        const newSelections = this.updateSelection(selection);
        if (newSelections) {
            this.setState({
                selections: newSelections,
                inProgressSelection: undefined
            });
            if (this.props.onSelection) this.props.onSelection(newSelections);
        }
    }
    updateSelection(selectionObj) {
        return (0, $eeb63405e607c2a2$export$6c7848d79ea81085)(selectionObj, this.state.selections, this.props.rootNode);
    }
    handleHighlight(highlight) {
        this.setState({
            highlight: highlight
        });
        if (this.props.onHighlight) {
            // need to expose highlight with modified coordinates, taking into account the x offset
            // caused by the species tree
            const mtx = this.props.svgMetrics;
            const modifiedHighlight = (0, ($parcel$interopDefault($1Kll1$lodash))).cloneDeep(highlight);
            const xOffset = mtx.width.speciesTree + mtx.width.text;
            if (modifiedHighlight.hasOwnProperty("x") && modifiedHighlight.hasOwnProperty("regionDims")) {
                modifiedHighlight.x += xOffset;
                modifiedHighlight.regionDims.x += xOffset;
                this.props.onHighlight(modifiedHighlight);
            }
        }
    }
    marginTransform() {
        const m = this.props.svgMetrics.layout.margin / 2;
        return `translate(${m},${m})`;
    }
    getGenomes(props = this.props) {
        return (0, $3ba3fb37090da528$export$5d5aa51867371914)(props.rootNode, props.nodeDisplayInfo).map((node)=>node.model.genome);
    }
    render() {
        const propsPassthrough = (0, ($parcel$interopDefault($1Kll1$lodash))).pick(this.props, [
            "nodeDisplayInfo",
            "svgMetrics"
        ]);
        const mtx = this.props.svgMetrics;
        const svgWidth = mtx.width.speciesTree + mtx.width.text;
        const style = {
            minWidth: mtx.width.vis
        };
        return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsxs)("div", {
            className: "gramene-search-vis",
            style: style,
            children: [
                /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("svg", {
                    width: svgWidth,
                    height: this.props.height,
                    children: /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("g", {
                        className: "taxonomy",
                        transform: this.marginTransform(),
                        children: /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)((0, $412f91be2b3621a9$export$2e2bcd8739ae039), {
                            node: this.props.rootNode,
                            isRoot: true,
                            ...this.state,
                            onSelectionStart: this.handleSelectionStart.bind(this),
                            onSelection: this.handleSelection.bind(this),
                            onHighlight: this.handleHighlight.bind(this),
                            ...propsPassthrough
                        })
                    })
                }),
                /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)((0, $26ed8e186f907c39$export$2e2bcd8739ae039), {
                    genomes: this.getGenomes(),
                    rootNode: this.props.rootNode,
                    globalStats: this.props.rootNode.globalResultSetStats(),
                    ...this.state,
                    onSelectionStart: this.handleSelectionStart.bind(this),
                    onSelection: this.handleSelection.bind(this),
                    onHighlight: this.handleHighlight.bind(this),
                    ...propsPassthrough
                })
            ]
        });
    }
}



const $08ed429e2991b5a8$var$windowResizeDebounceMs = 250;
class $08ed429e2991b5a8$var$Vis extends (0, ($parcel$interopDefault($1Kll1$react))).Component {
    constructor(props){
        super(props);
        this.updateProps = new (0, $530496d5ae59225d$export$2e2bcd8739ae039)("selectedTaxa");
        var rootNode = props.taxonomy;
        while(rootNode.children.length === 1)rootNode = rootNode.children[0];
        this.state = {
            nodeDisplayInfo: this.initNodeState(props.taxonomy, props.selectedTaxa),
            rootNodeId: rootNode.model.id
        };
        if (!(0, ($parcel$interopDefault($1Kll1$lodash))).isUndefined($parcel$global.addEventListener)) {
            this.resizeListener = (0, ($parcel$interopDefault($1Kll1$lodash))).debounce(this.updateAvailableWidth.bind(this), $08ed429e2991b5a8$var$windowResizeDebounceMs);
            $parcel$global.addEventListener("resize", this.resizeListener);
        }
    }
    componentDidMount() {
        this.updateAvailableWidth();
    }
    componentWillUnmount() {
        if (this.resizeListener) $parcel$global.removeEventListener("resize", this.resizeListener);
    }
    updateAvailableWidth() {
        const parentWidth = (0, ($parcel$interopDefault($1Kll1$reactdom))).findDOMNode(this).parentNode.clientWidth;
        const newMetrics = (0, $124e2536d5ac167e$export$2e2bcd8739ae039)(parentWidth);
        console.log("width is", parentWidth, "metrics are", newMetrics);
        if (this.didMetricsUpdate(newMetrics)) this.setState({
            metrics: newMetrics,
            nodeDisplayInfo: this.updateTaxonomyDisplayInfo(this.props, newMetrics)
        });
    }
    componentWillReceiveProps(newProps) {
        if (this.didResultsChange(newProps) || this.updateProps.differ(this.props, newProps)) {
            const newDisplayInfo = this.updateTaxonomyDisplayInfo(newProps);
            if (newDisplayInfo) this.setState({
                nodeDisplayInfo: newDisplayInfo
            });
        }
    }
    updateTaxonomyDisplayInfo(props = this.props, metrics = this.state.metrics) {
        if (metrics) {
            const intermediateDisplayInfo = this.updateNodeExpansionState(props.selectedTaxa);
            const newDisplayInfo = (0, $856009e104b5527d$export$2e2bcd8739ae039)((0, ($parcel$interopDefault($1Kll1$lodash))).get(metrics, "width.speciesTree"), // speciesTreeWidth,
            this.height(metrics, intermediateDisplayInfo), props.taxonomy, intermediateDisplayInfo, this.state.rootNodeId, props.selectedTaxa);
            return newDisplayInfo;
        } else console.log("Did not update taxonomy display info because no svg metrics available");
    }
    selectedTaxaWithParents(selectedTaxa) {
        const nodeIndex = this.props.taxonomy.indices.id;
        return (0, ($parcel$interopDefault($1Kll1$lodash))).reduce(selectedTaxa, (acc, val, selectedTaxonId)=>{
            const selectedNode = nodeIndex[selectedTaxonId];
            const parents = (0, ($parcel$interopDefault($1Kll1$lodash))).reduce(selectedNode.getPath(), (acc, parent)=>{
                acc[parent.model.id] = true;
                return acc;
            }, {});
            return (0, ($parcel$interopDefault($1Kll1$lodash))).assign(acc, parents);
        }, {});
    }
    updateNodeExpansionState(selectedTaxa) {
        const allSelected = (0, ($parcel$interopDefault($1Kll1$lodash))).size(selectedTaxa) == 0;
        const selectedTaxaWithParents = allSelected ? null : this.selectedTaxaWithParents(selectedTaxa);
        return (0, ($parcel$interopDefault($1Kll1$lodash))).mapValues(this.state.nodeDisplayInfo, (val, key)=>{
            const newVal = (0, ($parcel$interopDefault($1Kll1$lodash))).clone(val);
            newVal.expanded = allSelected || !!selectedTaxaWithParents[key];
            return newVal;
        });
    }
    initNodeState(taxonomy) {
        return (0, ($parcel$interopDefault($1Kll1$lodash)))(taxonomy.all()).keyBy("model.id").mapValues(()=>({
                expanded: true,
                highlight: false
            })).value();
    }
    getSetResultsCallCount(props) {
        return props.taxonomy.globalResultSetStats().timesSetResultsHasBeenCalled;
    }
    didResultsChange(props) {
        const newResultsState = this.getSetResultsCallCount(props);
        return this.genomeResultsState !== newResultsState;
    }
    updateResultsCount(props) {
        this.genomeResultsState = this.getSetResultsCallCount(props);
    }
    shouldComponentUpdate(newProps, newState) {
        const decision = this.didResultsChange(newProps) || this.didMetricsUpdate(newState.metrics) || this.updateProps.differ(this.props, newProps);
        this.updateResultsCount(newProps);
        return decision;
    }
    didMetricsUpdate(newMetrics) {
        return !(0, ($parcel$interopDefault($1Kll1$lodash))).isEqual(this.state.metrics, newMetrics);
    }
    rootNode() {
        return this.props.taxonomy.indices.id[this.state.rootNodeId];
    }
    height(metrics = this.state.metrics, nodeDisplayInfo = this.state.nodeDisplayInfo) {
        if (!metrics) throw new Error("No svg metrics available for call to height()");
        return (0, $3ba3fb37090da528$export$f27c46a4165fa319)(this.props.taxonomy, nodeDisplayInfo) * metrics.height.leafNode;
    }
    width() {
        if (!this.state.metrics) throw new Error("No svg metrics available for call to width()");
        return this.state.metrics.width.vis;
    }
    margin() {
        if (!this.state.metrics) throw new Error("No svg metrics available for call to width()");
        return this.state.metrics.layout.margin;
    }
    renderTaxonomy() {
        if (this.state.metrics) return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)((0, $51d08e07ac9e9607$export$2e2bcd8739ae039), {
            width: this.width() + this.margin(),
            height: this.height() + this.margin(),
            rootNode: this.rootNode(),
            selectedTaxa: this.props.selectedTaxa,
            nodeDisplayInfo: this.state.nodeDisplayInfo,
            onHighlight: this.props.onHighlight,
            onSelection: this.props.onSelection,
            svgMetrics: this.state.metrics
        });
    }
    render() {
        return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("div", {
            className: "taxogenomic-vis",
            children: this.renderTaxonomy()
        });
    }
}
var $08ed429e2991b5a8$export$2e2bcd8739ae039 = $08ed429e2991b5a8$var$Vis;


//# sourceMappingURL=index.js.map
